import React from 'react'

interface DescriptionProps {
  children: React.ReactNode;
}

export function Description ({ children }: DescriptionProps) {
  return <p className='body text-gray-500'>{children}</p>
}

Description.displayName = 'MarketplaceCard.Description'
